module.exports = __webpack_public_path__ + "img/pr-8.99261797.png";